const calculateStickyPartOffset = () => {
  let tabHeadingsHeight = document.querySelector(".product-tabs-headings").offsetHeight;
   let stickyPartOffset = tabHeadingsHeight;
    if (window.matchMedia('(max-width: 767px)').matches) {
  stickyPartOffset += document.querySelector(".swahdr").offsetHeight;

  } else {
    stickyPartOffset += document.querySelector(".swanavsec").offsetHeight;
  }

  return stickyPartOffset;
}

let isScrollingByClick = false;
const scrollToProductTabSection = $this => {

  const tabTitle = $this.dataset.tabTitle;

   let stickyPartOffset = calculateStickyPartOffset();

      // Temporarily disable the scroll event handling
        isScrollingByClick = true;
  
   let newStickyPartOffset = stickyPartOffset + 10;

  if(!window.matchMedia('(min-width: 769px)').matches){
      if(!$(".product-tabs-headings-wrapper.sticky").length) {
    newStickyPartOffset += $(".product-tabs-heading-wrapper:first").height();

  }
  }


  document.querySelectorAll(`.product-tabs-heading-wrapper`).forEach(productTabsHeading => productTabsHeading.classList.remove("active-tab"));
$this.classList.add("active-tab");

  setTimeout(function(){

          // Scroll the section into view within the container
    document.querySelector(`.product-tabs-heading-wrapper[data-tab-title="${tabTitle}"]`).scrollIntoView({
    behavior: 'smooth',
    block: 'start',
    inline: 'start'
    });
    
  }, 550);

    $('html, body').animate({
    scrollTop: $(`.product-tab-section[data-tab-section="${tabTitle}"]`).offset().top - newStickyPartOffset
    }, 500);

      // Re-enable scroll handling after the scrolling ends
        setTimeout(() => {
            isScrollingByClick = false;
        }, 1000); // 1000ms (1 second) should be enough time to complete the scroll
};
const $productTabHeadings = $(".product-tabs-headings");

    setTimeout(function() {

             $('.product-recommendations-wrapper .collection-products > div').slick({
        // infinite: true,
        slidesToShow:3,
              dots: false,
              arrows: true,
        slidesToScroll: 1,
               adaptiveHeight: true,
          responsive: [
                    {
            breakpoint: 767,
            settings: {
              infinite: true,
              slidesToShow: 1,
              dots: true,
              arrows: false,
              slidesToScroll: 1
            }
          }
          ]
      
        });
    
    }, 2000);

    
  document.addEventListener("DOMContentLoaded", (event) => {   
  const options = {
  threshold:0.25
  }

const productTabSections = document.querySelectorAll(".product-tab-sections-wrapper .product-tab-section");

const navHighlighter = () => {

   if (isScrollingByClick) return; // Do nothing if scrolling by click

  // Get current scroll position
  let scrollY = window.pageYOffset;
  let stickyPartOffset = calculateStickyPartOffset() + 70;


  var productTabs = $('.product-tabs-headings-wrapper.sticky-tab-headings');
var heightThreshold = $(".product-tabs-sections").offset().top;

let stickyPartOffset1 = calculateStickyPartOffset();

heightThreshold -= stickyPartOffset1;

  heightThreshold += 30;
  
  if(scrollY < heightThreshold) {
    return;
  }

  let activeSection;
  
  // Now we loop through sections to get height, top and ID values for each
  productTabSections.forEach(productTabSection => {
    let sectionHeight = productTabSection.offsetHeight;
    let sectionTop = productTabSection.offsetTop - stickyPartOffset;

   if(document.querySelector(`.product-tabs-heading-wrapper[data-tab-title="${productTabSection.dataset.tabSection}"]`)){

      if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight){
      
      activeSection = productTabSection.dataset.tabSection;
      } 

      }

  });

   
    if(document.querySelector(`.product-tabs-heading-wrapper[data-tab-title="${activeSection}"]`)){

   // setTimeout(function(){
    
    // Scroll the section into view within the container
    document.querySelector(`.product-tabs-heading-wrapper[data-tab-title="${activeSection}"]`).scrollIntoView({
    behavior: 'smooth',
    block: 'start',
    inline: 'start'
    });

      
 document.querySelectorAll(`.product-tabs-heading-wrapper`).forEach(productTabsHeading => productTabsHeading.classList.remove("active-tab"));
document.querySelector(`.product-tabs-heading-wrapper[data-tab-title="${activeSection}"]`).classList.add("active-tab");
      
  //  }, 500);

    }
  
}

const scrollProductTab = $direction => {

  let scrollableWrapper = document.querySelector(".product-tabs-headings");
  scrollableWrapper.style.scrollBehaviour = "smooth";
  let scrollAmount = 110;
  if($direction == "right"){

    scrollableWrapper.scrollLeft += scrollAmount;
  } else {
    scrollableWrapper.scrollLeft -= scrollAmount
  }
}
window.scrollProductTab = scrollProductTab;
   // Add an event listener listening for scroll
window.addEventListener("scroll", () => {
 // setTimeout(function(){
  navHighlighter();
  //}, 200)
}); 

  }); 

const showReviews = () => {

     setTimeout(function(){
        $('html, body').animate({
    scrollTop: $(document.querySelector('[data-tab-section*="description-parts-resenas-"]')).offset().top - 100
    }, 250);
   }, 500)

}
const showMoreContent = $this => {

  const currentScrollPosition = window.scrollY;
  let isCollasped = $this.closest(".product-tab-section").classList.contains("collapsed");
  $this.closest(".product-tab-section").classList.toggle("collapsed");

     let stickyPartOffset = calculateStickyPartOffset();

   let newStickyPartOffset = stickyPartOffset + 100;
  if(!$(".product-tabs-headings-wrapper.sticky").length) {
    newStickyPartOffset += $(".product-tabs-heading-wrapper:first").height();
  }

     // Animate scrolling to the end of the section
  if(!isCollasped){
      let $tabSection = $($this.closest(".product-tab-section"));
        $('html, body').animate({
            scrollTop: ($tabSection.offset().top + $tabSection.outerHeight() - $(window).height())+150
        }, 300);
  } else {

   window.scrollTo(0, currentScrollPosition);
    
  }

}

$(function() {
var productTabs = $('.product-tabs-headings-wrapper.sticky-tab-headings');
var tabs = document.querySelector('.product-tabs-headings-wrapper.sticky-tab-headings');
var heightThreshold = $(".product-tabs-sections").offset().top;
var heightThreshold_end  = $(".product-tabs-sections").offset().top +$(".product-tabs-sections").height();

let stickyPartOffset = calculateStickyPartOffset();

heightThreshold -= stickyPartOffset;

var heightThreshold_end  = heightThreshold +$(".product-tabs-sections").height();

$(window).scroll(function() {

  setTimeout(function(){

var scroll = $(window).scrollTop();

 if (window.matchMedia('(max-width: 767px)').matches) {
  topOffset = document.querySelector(".swahdr").offsetHeight;
  } else {
  topOffset = document.querySelector(".swanavsec").offsetHeight;
  }

  let scrollToCheck = window.matchMedia('(max-width: 767px)').matches ? (heightThreshold): (heightThreshold);

  scroll = parseInt(scroll);
  scrollToCheck = parseInt(scrollToCheck);
  if(scroll < scrollToCheck) {
     productTabs.removeClass('sticky');
    return;
  }
     
    if (scroll >= scrollToCheck && scroll <=  heightThreshold_end ) {
      productTabs.addClass('sticky');

            // Offset the scroll position by a certain amount (e.g., 10px) to reveal content above
        if (!tabs.classList.contains('scroll-adjusted')) {
            window.scrollTo({
                top: window.scrollY - 10, // Adjust the offset as needed
                behavior: 'smooth'
            });
            tabs.classList.add('scroll-adjusted');
        }
      
        if(productTabs) {
    productTabs.css({top:  `${topOffset}px`});
  }
    } else {

        tabs.classList.remove('scroll-adjusted');
        productTabs.removeClass('sticky');
    }
  }, 100)
 
  });

 let allProductSections = document.querySelector(".product-tab-sections-wrapper").querySelectorAll(".product-tab-section");
  allProductSections.forEach(allProductSection => {

    let innerContent = allProductSection.querySelector(".station-tabs-content");
    if(innerContent && innerContent.clientHeight >= 700) {
      allProductSection.classList.add("collapsed");
      allProductSection.querySelector(".view-more-content")?.classList.remove("hide");
    }
  });

})